import {Grid, Typography, TypographyProps} from '@mui/material';

export interface CenteredTextProps extends TypographyProps {
  text: string;
  minHeight?: number;
  startComponent?: React.ReactNode;
  endComponent?: React.ReactNode;
}

export default function CenteredText({text, minHeight, startComponent, endComponent, ...props}: CenteredTextProps) {
  return (
    <Grid
      sx={{width: '100%', height: '100%', minHeight}}
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      {startComponent}
      {}
      <Typography marginBottom={0} {...props}>
        {text}
      </Typography>
      {endComponent}
    </Grid>
  );
}
